import { render } from "./LandingComponent.vue?vue&type=template&id=9f6b1696&ts=true"
import script from "./LandingComponent.vue?vue&type=script&lang=ts"
export * from "./LandingComponent.vue?vue&type=script&lang=ts"

import "./LandingComponent.vue?vue&type=style&index=0&id=9f6b1696&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__